import React from "react";
import "./Insurer_cards.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUmbrella } from "@fortawesome/free-solid-svg-icons";

function Insurer_cards({ className, icon, priceText, infoText, financeYear }) {
  return (
    <>
      <div className="Insurer_cards">
        <div className="hading_holder">
          <FontAwesomeIcon className={className} icon={icon} />
          <h6>{priceText}</h6>
        </div>
        <div className="text_holder">
          <p>{infoText}</p>
        </div>
        <div className="card_bottom_text">
          <p>{financeYear}</p>
        </div>
      </div>
    </>
  );
}

export default Insurer_cards;
